import React from 'react';
import { CheckCircle } from 'lucide-react';
const includes = ['Arquitectura de la formulación profesional', 'Formulación por escenarios reales', 'Formulación correctiva y casos complejos', 'Protocolos y criterio experto', 'Kit profesional de plantillas para coloristas™', 'Todo diseñado para trabajar con más precisión real'];
export function AulaListaSection() {
  return <section className="bg-white py-16 px-5" data-id="element-22">
      <div className="max-w-xl mx-auto" data-id="element-23">
        <div className="text-center mb-12" data-id="element-24">
          <span className="bg-brand-gold/10 text-brand-gold text-[10px] font-black px-4 py-1.5 rounded-full uppercase tracking-widest mb-6 inline-block border border-brand-gold/20" data-id="element-25">
            ⭐ EXCLUSIVO DEL PACK COMPLETO
          </span>
          <h2 className="text-2xl md:text-3xl font-black text-slate-900 mb-4" data-id="element-26">
            🧠 ¿Qué agrega el Sistema Formulación Capilar™?
          </h2>
          <p className="text-base text-slate-500 font-medium max-w-md mx-auto" data-id="element-27">
            Ya entendés teoría…{' '}
            <span className="text-brand-gold font-bold" data-id="element-28">
              👉 ahora necesitás criterio avanzado
            </span>{' '}
            para formular mejor en escenarios reales.
          </p>
        </div>

        <div className="bg-slate-50 border border-slate-100 rounded-3xl p-8 mb-10 shadow-sm" data-id="element-29">
          <h3 className="text-lg font-black text-center mb-8 uppercase tracking-wider text-brand-gold" data-id="element-30">
            💥 ESTO INCLUYE:
          </h3>
          <div className="space-y-4" data-id="element-31">
            {includes.map((item, idx) => <div key={idx} className="flex items-center gap-4 bg-white p-4 rounded-xl border border-slate-100 shadow-sm" data-id="element-32">
                <CheckCircle className="text-brand-gold flex-shrink-0" size={24} data-id="element-33" />
                <span className="text-sm md:text-base font-bold text-slate-700" data-id="element-34">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        <p className="text-center text-slate-400 text-xs font-bold uppercase tracking-widest" data-id="element-35">
          La opción más recomendada para resultados más profesionales
        </p>
      </div>
    </section>;
}